import {
  createBound,
  MockBound,
} from '@dapi/sdk/spec';
import {
  cphLhrOslDisruptionStatus,
  cphOslAcknowledgeDisruptionStatus,
  cphOslDisruptionStatus,
  cphOslScheduleChangeStatus,
  helTkuAcknowledgeDisruptionStatus,
  helTkuDisruptionStatus,
  oslCphAcknowledgeDisruptionStatus,
  oslCphAcknowledgedStatusWithCityChange,
  oslCphDisruptionStatus,
  oslCphDisruptionStatusWithCityChange,
  oslCphDisruptionStatusWithDifferentFlightId,
  oslCphScheduleChangeStatus,
  oslLhrDisruptionStatus,
  tkuHelAcknowledgeDisruptionStatus,
  tkuHelDisruptionStatus,
  unOnlyDisruptionStatus,
  unOnlyDisruptionStatusFixedDate,
  unOnlyReturnFlightDisruptionStatus,
} from './disruption-status';
import {
  arnEwrFlightItem,
  cphLhrFlightItem,
  cphOslFlightItem,
  cphOslOriginalFlightItemWithSameFlight,
  cphOslUnOnlyFlightItem,
  cphOslUnOnlyFlightItemFixedDate,
  helTkuFlightItem,
  lhrOslFlightAI,
  lhrOslFlightItem,
  oslCphFlightItem,
  oslCphOriginalFlightItemWithSameFlight,
  oslCphUnOnlyFlightItem,
  oslLhrFlightItem,
  oslTkuFlightItem,
  tkuHelFlightItem,
} from './flights';

export const boundId1 = '2MEVf66495f6437';
export const boundId2 = '2MEVf020b389f93';

export const cphOslBound: MockBound = createBound({
  flights: [cphOslFlightItem],
  template: {
    airBoundId: boundId1,
    originLocationCode: 'CPH',
    destinationLocationCode: 'OSL',
    duration: 4200,
    disruptionStatus: cphOslDisruptionStatus
  }
});

export const oslLhrBound: MockBound = createBound({
  flights: [oslLhrFlightItem],
  template: {
    airBoundId: boundId2,
    originLocationCode: 'OSL',
    destinationLocationCode: 'LHR',
    duration: 4200,
    disruptionStatus: oslLhrDisruptionStatus
  }
});

export const cphLhrOslBound: MockBound = createBound({
  flights: [cphLhrFlightItem, lhrOslFlightItem],
  template: {
    airBoundId: boundId1,
    originLocationCode: 'CPH',
    destinationLocationCode: 'OSL',
    duration: 4200,
    disruptionStatus: cphLhrOslDisruptionStatus
  }
});

export const oslCphBound: MockBound = createBound({
  flights: [oslCphFlightItem],
  template: {
    airBoundId: boundId2,
    originLocationCode: 'OSL',
    destinationLocationCode: 'CPH',
    duration: 4200,
    disruptionStatus: oslCphDisruptionStatus
  }
});

export const oslCphDisruptedBound: MockBound = createBound({
  flights: [oslCphFlightItem],
  template: {
    airBoundId: boundId1,
    originLocationCode: 'OSL',
    destinationLocationCode: 'CPH',
    duration: 4200,
    disruptionStatus: oslCphDisruptionStatusWithDifferentFlightId
  }
});

export const oslCphDisruptedCityChangeBound: MockBound = createBound({
  flights: [oslTkuFlightItem],
  template: {
    airBoundId: boundId1,
    originLocationCode: 'OSL',
    destinationLocationCode: 'TKU',
    duration: 5100,
    disruptionStatus: oslCphDisruptionStatusWithCityChange
  }
});

export const oslCphAcknowledgedCityChangeBound: MockBound = createBound({
  flights: [oslTkuFlightItem],
  template: {
    airBoundId: boundId1,
    originLocationCode: 'OSL',
    destinationLocationCode: 'TKU',
    duration: 5100,
    disruptionStatus: oslCphAcknowledgedStatusWithCityChange
  }
});

export const tkuHelDisruptedBound: MockBound = createBound({
  flights: [tkuHelFlightItem],
  template: {
    airBoundId: boundId2,
    originLocationCode: 'TKU',
    destinationLocationCode: 'HEL',
    duration: 4200,
    disruptionStatus: tkuHelDisruptionStatus
  }
});

export const unOnlyBound: MockBound = createBound({
  flights: [cphOslUnOnlyFlightItem],
  template: {
    airBoundId: boundId1,
    destinationLocationCode: 'OSL',
    disruptionStatus: unOnlyDisruptionStatus,
    duration: 4200,
    originLocationCode: 'CPH'
  }
});

export const unOnlyBoundFixedDate: MockBound = createBound({
  flights: [cphOslUnOnlyFlightItemFixedDate],
  template: {
    airBoundId: boundId1,
    destinationLocationCode: 'OSL',
    disruptionStatus: unOnlyDisruptionStatusFixedDate,
    duration: 4200,
    originLocationCode: 'CPH'
  }
});

export const unOnlyReturnBound: MockBound = createBound({
  flights: [oslCphUnOnlyFlightItem],
  template: {
    airBoundId: boundId2,
    originLocationCode: 'OSL',
    destinationLocationCode: 'CPH',
    duration: 4200,
    disruptionStatus: unOnlyReturnFlightDisruptionStatus
  }
});

export const helTkuBound: MockBound = createBound({
  flights: [helTkuFlightItem],
  template: {
    airBoundId: boundId1,
    id: 'ST3',
    originLocationCode: 'HEL',
    destinationLocationCode: 'TKU',
    duration: 2100,
    disruptionStatus: helTkuDisruptionStatus
  }
});

export const tkuHelBound: MockBound = createBound({
  flights: [tkuHelFlightItem],
  template: {
    airBoundId: boundId2,
    id: 'ST4',
    originLocationCode: 'TKU',
    destinationLocationCode: 'HEL',
    duration: 2100,
    disruptionStatus: tkuHelDisruptionStatus
  }
});

export const cphOslAcknowledgedBound: MockBound = createBound({
  flights: [{
    ...cphOslFlightItem,
    statusCode: 'HK',
    bookingStatus: {
      name: 'Holding confirmed'
    }
  }],
  template: {
    airBoundId: boundId1,
    originLocationCode: 'CPH',
    destinationLocationCode: 'OSL',
    duration: 4200,
    disruptionStatus: cphOslAcknowledgeDisruptionStatus
  }
});

export const cphOslScheduleChangeBound: MockBound = createBound({
  template: {
    airBoundId: boundId1,
    originLocationCode: 'CPH',
    destinationLocationCode: 'OSL',
    disruptionStatus: cphOslScheduleChangeStatus,
    duration: 4200,
    flights: [cphOslOriginalFlightItemWithSameFlight]
  }
});

export const oslCphScheduleChangeBound: MockBound = createBound({
  template: {
    airBoundId: boundId2,
    originLocationCode: 'OSL',
    destinationLocationCode: 'CPH',
    disruptionStatus: oslCphScheduleChangeStatus,
    duration: 4200,
    flights: [oslCphOriginalFlightItemWithSameFlight]
  }
});

export const cphLhrOslBoundScheduleChange: MockBound = createBound({
  template: {
    airBoundId: boundId1,
    originLocationCode: 'CPH',
    destinationLocationCode: 'OSL',
    duration: 4200,
    disruptionStatus: cphOslScheduleChangeStatus,
    flights: [{
      ...cphLhrFlightItem,
      statusCode: 'HK'
    }, {
      ...lhrOslFlightItem,
      flight: lhrOslFlightAI
    }]
  }
});

export const cphOslBoundInvoluntaryRefundEligible: MockBound = createBound({
  template: {
    airBoundId: boundId1,
    originLocationCode: 'CPH',
    destinationLocationCode: 'OSL',
    duration: 4200,
    disruptionStatus: cphOslDisruptionStatus,
    flights: [{
      ...cphOslFlightItem,
      id: 'ST2',
      statusCode: 'TK'
    }]
  }
});

export const oslCphNonDisruptedBound: MockBound = createBound({
  flights: [{
    ...oslCphFlightItem,
    statusCode: 'HK'
  }],
  template: {
    airBoundId: boundId2,
    originLocationCode: 'OSL',
    destinationLocationCode: 'CPH',
    duration: 4200
  }
});

export const oslCphAcknowledgedBound: MockBound = createBound({
  flights: [{
    ...oslCphFlightItem,
    statusCode: 'HK',
    bookingStatus: {
      name: 'Holding confirmed'
    }
  }],
  template: {
    airBoundId: boundId2,
    originLocationCode: 'OSL',
    destinationLocationCode: 'CPH',
    duration: 4200,
    disruptionStatus: oslCphAcknowledgeDisruptionStatus
  }
});

export const helTkuAcknowledgedBound: MockBound = createBound({
  flights: [{
    ...helTkuFlightItem,
    statusCode: 'HK',
    bookingStatus: {
      name: 'Holding confirmed'
    }
  }],
  template: {
    airBoundId: boundId1,
    originLocationCode: 'HEL',
    destinationLocationCode: 'TKU',
    duration: 4200,
    disruptionStatus: helTkuAcknowledgeDisruptionStatus
  }
});

export const tkuHelAcknowledgedBound: MockBound = createBound({
  flights: [{
    ...tkuHelFlightItem,
    statusCode: 'HK',
    bookingStatus: {
      name: 'Holding confirmed'
    }
  }],
  template: {
    airBoundId: boundId2,
    originLocationCode: 'TKU',
    destinationLocationCode: 'HEL',
    duration: 4200,
    disruptionStatus: tkuHelAcknowledgeDisruptionStatus
  }
});

export const arnEwrBound: MockBound = createBound({
  flights: [arnEwrFlightItem],
  template: {
    airBoundId: '1',
    originLocationCode: 'ARN',
    destinationLocationCode: 'EWR',
    duration: 31_800
  }
});
